// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"749e47a1","952":"df9524a7"}[chunkId] + ".chunk.js";
};